function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data,
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get("quantity-selector")) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".qty");
      this.step = Number(this.input.getAttribute("step")) || 1;
      this.changeEvent = new Event("change", {
        bubbles: true,
      });
      this.subtract = this.querySelector(".minus");
      this.add = this.querySelector(".plus");

      if (this.subtract) {
        this.subtract.addEventListener("click", () =>
          this.change_quantity(-1 * this.step)
        );
      }
      if (this.add) {
        this.add.addEventListener("click", () =>
          this.change_quantity(1 * this.step)
        );
      }
    }

    connectedCallback() {
      this.classList.add("buttons_added");
      this.syncDisabledStateFromMarkup();
      this.validateQtyRules();
    }

    change_quantity(change) {
      let quantity = Number(this.input.value);

      if (isNaN(quantity)) quantity = 1;

      const minAttr = this.input.getAttribute("min");
      const maxAttr = this.input.getAttribute("max");
      const min = minAttr ? Number(minAttr) : null;
      const max = maxAttr ? Number(maxAttr) : null;

      if (min !== null && (quantity + change) < min) {
        return;
      }
      if (max !== null && (quantity + change) > max) {
        return;
      }

      quantity += change;

      quantity = Math.max(quantity, 1);

      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }

    validateQtyRules() {
      const value = parseInt(this.input.value, 10) || 0;
      const minAttr = this.input.getAttribute("min");
      const maxAttr = this.input.getAttribute("max");
      const min = minAttr ? parseInt(minAttr, 10) : null;
      const max = maxAttr ? parseInt(maxAttr, 10) : null;

      if (this.subtract) {
        const shouldDisableSubtract = min !== null ? value <= min : false;
        this._setButtonDisabled(this.subtract, shouldDisableSubtract);
      }
      if (this.add) {
        const serverDisabledAttr = this.add.hasAttribute && this.add.hasAttribute("disabled");
        const serverFreebieFlag = this.add.dataset && this.add.dataset.freebie === 'true';
        const serverDisabled = !!(serverDisabledAttr || serverFreebieFlag || this.add.classList.contains('disabled'));
        const shouldDisableAdd = serverDisabled || (max !== null ? value >= max : false);
        this._setButtonDisabled(this.add, shouldDisableAdd);
      }
    }

    _setButtonDisabled(buttonEl, disabled) {
      if (!buttonEl) return;

      if (disabled) {
        buttonEl.setAttribute("disabled", "");
        buttonEl.classList.add("disabled");
      } else {
        buttonEl.removeAttribute("disabled");
        buttonEl.classList.remove("disabled");
      }
    }
    syncDisabledStateFromMarkup() {
      if (this.subtract && this.subtract.hasAttribute("disabled")) {
        this.subtract.classList.add("disabled");
      }
      if (this.add && this.add.hasAttribute("disabled")) {
        this.add.classList.add("disabled");
      }
    }
  }

  customElements.define("quantity-selector", QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector(".sub-menu");
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener("click", (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains("active")) {
      submenu.classList.add("active");
    } else {
      submenu.classList.remove("active");
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll(".thb-arrow");
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector(".product-card-swatches");
      this.image = this.querySelector(
        ".product-featured-image-link .product-primary-image"
      );
      this.additional_images = this.querySelectorAll(
        ".product-secondary-image"
      );
      this.additional_images_nav = this.querySelectorAll(
        ".product-secondary-images-nav li"
      );
      this.quick_add = this.querySelector(
        ".product-card--add-to-cart-button-simple"
      );
      this.size_options = this.querySelector(".product-card-sizes");
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector(".product-featured-image");
      const mousemove = function (e) {
        if (
          !e.target.parentElement.classList.contains(
            "product-featured-image-link"
          )
        ) {
          return;
        }
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains("hover")) {
            image.classList.remove("hover");
            if (nav.length) {
              nav[index].classList.remove("active");
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains("hover")) {
            selimg.classList.add("hover");
            if (nav.length) {
              nav[sel].classList.add("active");
            }
          }
        }
      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove("hover");
          if (nav.length) {
            nav[index].classList.remove("active");
          }
        });
      };
      if (image_container) {
        image_container.addEventListener("touchstart", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchmove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchend", mouseleave, {
          passive: true,
        });
        image_container.addEventListener("mouseenter", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mousemove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mouseleave", mouseleave, {
          passive: true,
        });
      }

      images.forEach(function (image) {
        window.addEventListener("load", (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll(".product-card-swatch"),
        org_srcset = image ? image.dataset.srcset : "";
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener("load", (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener("mouseover", () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove("active");
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute("srcset", swatch.dataset.srcset);
            } else {
              image.setAttribute("srcset", org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] =
              swatch.querySelector("span").innerText;
            this.updateMasterId();
          }
          swatch.classList.add("active");
        });
        swatch.addEventListener("click", function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener("click", this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll(
        ".product-card-sizes--size"
      ),
        featured_image = this.querySelector(".product-featured-image"),
        has_hover = featured_image.classList.contains("thb-hover"),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(",");

      this.updateMasterId();

      size_parent.addEventListener(
        "mouseenter",
        () => {
          if (has_hover) {
            featured_image.classList.remove("thb-hover");
          }
        },
        {
          passive: true,
        }
      );
      size_parent.addEventListener(
        "mouseleave",
        () => {
          if (has_hover) {
            featured_image.classList.add("thb-hover");
          }
        },
        {
          passive: true,
        }
      );
      size_list.forEach((size) => {
        size.addEventListener("click", (evt) => {
          evt.preventDefault();

          if (size.classList.contains("is-disabled")) {
            return;
          }
          this.current_options[this.size_index] =
            size.querySelector("span").innerText;
          this.updateMasterId();

          size.classList.add("loading");
          size.setAttribute("aria-disabled", true);
          const config = {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/javascript",
            },
          };
          let formData = new FormData();

          formData.append("id", this.currentVariant.id);
          formData.append("quantity", 1);
          formData.append(
            "sections",
            this.getSectionsToRender().map((section) => section.section)
          );
          formData.append("sections_url", window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent("cart:item-added", {
                product: response.hasOwnProperty("items")
                  ? response.items[0]
                  : response,
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove("loading");
              size.removeAttribute("aria-disabled");
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.current_options[index] === option;
          })
          .includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {
        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map(
            (value, index) => {
              return {
                value,
                index: `option${index + 1}`,
              };
            }
          );

          const available_options = this.createAvailableOptionsTree(
            variant_data,
            selected_options
          );

          const fieldset_options =
            Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (
              this.size_options.querySelectorAll(".product-card-sizes--size")
                .length
            ) {
              this.size_options
                .querySelectorAll(".product-card-sizes--size")
                .forEach((input, input_i) => {
                  input.classList.toggle(
                    "is-disabled",
                    fieldset_options[input_i].isUnavailable
                  );
                });
            }
          }
        } else {
          if (
            this.size_options.querySelectorAll(".product-card-sizes--size")
              .length
          ) {
            this.size_options
              .querySelectorAll(".product-card-sizes--size")
              .forEach((input, input_i) => {
                input.classList.add("is-disabled");
              });
          }
        }
      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index]
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0
            );

            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index
              )
            ) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        }
      );
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add("loading");
      this.quick_add.setAttribute("aria-disabled", true);

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      let formData = new FormData();

      formData.append("id", this.quick_add.dataset.productId);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove("loading");
          this.quick_add.removeAttribute("aria-disabled");
        });

      return false;
    }
    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        if (typeof CartDrawer !== "undefined") {
          new CartDrawer();
        }
        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
      });

      if (document.getElementById("Cart-Drawer")) {
        document.getElementById("Cart-Drawer").classList.add("active");
        document.body.classList.add("open-cart");
        document.body.classList.add("open-cc");
        if (
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
        ) {
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
            .classList.add("active");
        }
        dispatchCustomEvent("cart-drawer:open");
      }
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define("product-card", ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector(".header-section"),
      header_main = document.getElementById("header"),
      menu = document.getElementById("mobile-menu"),
      toggle = document.querySelector(".mobile-toggle-wrapper"),
      setHeaderOffset = this.setHeaderOffset,
      setAnnouncementHeight = this.setAnnouncementHeight,
      setHeaderHeight = this.setHeaderHeight;

    if (!header_main) {
      return;
    }
    document.addEventListener("keyup", (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === "ESCAPE") {
          toggle.removeAttribute("open");
          toggle.classList.remove("active");
        }
      }
    });
    toggle.querySelector(".mobile-toggle").addEventListener("click", (e) => {
      setAnnouncementHeight(header);
      if (toggle.classList.contains("active")) {
        e.preventDefault();
        document.body.classList.remove("overflow-hidden");
        toggle.classList.remove("active");
        this.closeAnimation(toggle);
      } else {
        document.body.classList.add("overflow-hidden");
        setTimeout(() => {
          toggle.classList.add("active");
        });
      }
      window.dispatchEvent(new Event("resize.resize-select"));
    });

    // Mobile Menu offset
    window.addEventListener(
      "scroll",
      function () {
        setHeaderOffset(header);
        setHeaderHeight(header_main);
        // Sticky Header Class
        if (header_main.classList.contains("header-sticky--active")) {
          let offset =
            parseInt(header_main.getBoundingClientRect().top, 10) +
            document.documentElement.scrollTop;

          header_main.classList.toggle(
            "is-sticky",
            window.scrollY >= offset && window.scrollY > 0
          );
        }
      },
      {
        passive: true,
      }
    );
    window.dispatchEvent(new Event("scroll"));

    if (document.getElementById("shopify-section-announcement-bar")) {
      const a_bar = document.getElementById("shopify-section-announcement-bar");
      window.addEventListener(
        "resize",
        function () {
          setAnnouncementHeight(a_bar);
        },
        {
          passive: true,
        }
      );
      window.dispatchEvent(new Event("resize"));
    }
    // Buttons.
    menu
      .querySelectorAll("summary")
      .forEach((summary) =>
        summary.addEventListener("click", this.onSummaryClick.bind(this))
      );
    menu
      .querySelectorAll("button")
      .forEach((button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
  }
  setAnnouncementHeight(a_bar) {
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty(
      "--announcement-height",
      h + "px"
    );
  }
  setHeaderOffset(header) {
    let h = header.getBoundingClientRect().top;
    document.documentElement.style.setProperty("--header-offset", h + "px");
  }
  setHeaderHeight(header) {
    let h = header.clientHeight;
    document.documentElement.style.setProperty("--header-height", h + "px");
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".link-container");
    const isOpen = detailsElement.hasAttribute("open");

    setTimeout(() => {
      detailsElement.classList.add("menu-opening");
      parentMenuElement && parentMenuElement.classList.add("submenu-open");
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        detailsElement.querySelectorAll("details").forEach((details) => {
          details.removeAttribute("open");
          details.classList.remove("menu-opening");
          details.classList.remove("submenu-open");
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll(
        ".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu"
      );

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener(
        "resize",
        debounce(function () {
          _this.resizeSubMenus();
        }, 100)
      );

      window.dispatchEvent(new Event("resize"));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ":scope >.menu-item-has-children>.sub-menu"
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l =
              sub_submenu.parentElement.parentElement.getBoundingClientRect()
                .left +
              sub_submenu.parentElement.parentElement.clientWidth +
              10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (
            sub_submenu.parentElement.classList.contains("left-submenu")
          ) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get("side-panel-close")) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector(".click-capture");

      this.onClick = (e) => {
        let panel = this.closest(".side-panel");

        // fallback (ESC or overlay click)
        if (!panel) {
          const panels = document.querySelectorAll(".side-panel.active");
          panel = panels[panels.length - 1]; // topmost panel
        }

        if (panel) {
          this.close_panel(e, panel);
        }
      };
      // Add functionality to buttons
      this.addEventListener("click", this.onClick.bind(this));
      document.addEventListener("panel:close", this.onClick.bind(this));
      if (!this.cc.hasAttribute("initialized")) {
        this.cc.addEventListener("click", this.onClick.bind(this));
        this.cc.setAttribute("initialized", "");
      }
    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest(".side-panel.active");

        if (!panel) {
          return;
        }
      }
      if (
        panel.classList.contains("product-drawer") ||
        document.body.classList.contains("open-quick-view")
      ) {
        this.close_quick_view();
      } else if (panel.classList.contains("cart-drawer")) {
        dispatchCustomEvent("cart-drawer:close");
        if (panel.querySelector(".product-recommendations--full")) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel
              .querySelector(".product-recommendations--full")
              .classList.remove("active");
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel.classList.remove("active");
            // Only remove open-cc if no other active panels exist
            if (document.querySelectorAll(".side-panel.active").length === 0) {
              document.body.classList.remove("open-cc");
            }
            document.body.classList.remove("open-cart");
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector(".product-recommendations--full")) {
            if (!document.body.classList.contains("open-quick-view")) {
              setTimeout(() => {
                panel.classList.remove("active");
                // Only remove open-cc if no other active panels exist
                if (document.querySelectorAll(".side-panel.active").length === 0) {
                  document.body.classList.remove("open-cc");
                }
                document.body.classList.remove("open-cart");
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove("active");
            // Only remove open-cc if no other active panels exist
            if (document.querySelectorAll(".side-panel.active").length === 0) {
              document.body.classList.remove("open-cc");
            }
            document.body.classList.remove("open-cart");
          }
        }
      } else {
        panel.classList.remove("active");
        // Only remove open-cc if no other active panels exist
        if (document.querySelectorAll(".side-panel.active").length === 0) {
          document.body.classList.remove("open-cc");
        }
      }
    }
    close_quick_view() {
      let panel = document.getElementById("Product-Drawer");

      if (panel.querySelector(".product-quick-images--container")) {
        panel
          .querySelector(".product-quick-images--container")
          .classList.remove("active");
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove("active");
        if (
          !document.body.classList.contains("open-cart") ||
          !document.body.classList.contains("open-quick-view")
        ) {
          // Only remove open-cc if no other active panels exist
          if (document.querySelectorAll(".side-panel.active").length === 0) {
            document.body.classList.remove("open-cc");
          }
        }
        document.body.classList.remove("open-quick-view");
      } else {
        if (panel.querySelector(".product-quick-images--container")) {
          setTimeout(() => {
            panel.classList.remove("active");
            if (
              !document.body.classList.contains("open-cart") ||
              !document.body.classList.contains("open-quick-view")
            ) {
              // Only remove open-cc if no other active panels exist
              if (document.querySelectorAll(".side-panel.active").length === 0) {
                document.body.classList.remove("open-cc");
              }
            }
            document.body.classList.remove("open-quick-view");
            panel.querySelector("#Product-Drawer-Content").innerHTML = "";
          }, 500);
        }
      }
    }
  }
  customElements.define("side-panel-close", PanelClose);

  document.addEventListener("keyup", (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === "ESCAPE") {
        dispatchCustomEvent("panel:close");
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {
  constructor() {
    this.container = document.getElementById("Cart-Drawer");

    if (!this.container) {
      return;
    }

    if (window.__CART_DRAWER__) return window.__CART_DRAWER__;
    window.__CART_DRAWER__ = this;

    let _this = this,
      button = document.getElementById("cart-drawer-toggle"),
      quantities = this.container.querySelectorAll(".quantity input");

    // Add functionality to buttons
    button.addEventListener("click", (e) => {
      e.preventDefault();
      if (window.location.pathname !== "/cart") {
        document.body.classList.add("open-cc");
        document.body.classList.add("open-cart");
        this.container.classList.add("active");
      }
      this.container.focus();
      setTimeout(() => {
        if (this.container.querySelector(".product-recommendations--full")) {
          this.container
            .querySelector(".product-recommendations--full")
            .classList.add("active");
        }
      });
      dispatchCustomEvent("cart-drawer:open");
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener("cart:refresh", (event) => {
      this.refresh();
    });

    this.container.addEventListener(
      "change",
      this.debouncedOnChange.bind(this)
    );

    this.removeProductEvent();
    this.notesToggle();

    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains("qty")) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }

  removeProductEvent() {
    // Only attach once to the container
    if (this.removeListenerAttached) return;

    this.container.addEventListener("click", (event) => {
      const removeBtn = event.target.closest('.remove');
      if (!removeBtn) return;

      event.preventDefault();

      const index = removeBtn?.dataset?.index;
      if (typeof index === 'undefined') return;

      this.updateQuantity(index, "0");
    });

    this.removeListenerAttached = true;
  }

  getSectionsToRender() {
    return [
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".cart-drawer",
      },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector("#CartDrawerTerms"),
      checkout_button = this.container.querySelector(".button.checkout");

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener("click", function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById("order-note-toggle");

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener("click", (event) => {
      notes_toggle.nextElementSibling.classList.add("active");
    });
    notes_toggle.nextElementSibling
      .querySelectorAll(".button, .order-note-toggle__content-overlay")
      .forEach((el) => {
        el.addEventListener("click", (event) => {
          notes_toggle.nextElementSibling.classList.remove("active");
          this.saveNotes();
        });
      });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      body: JSON.stringify({
        note: document.getElementById("mini-cart__notes").value,
      }),
    });
  }
  updateQuantity(line, quantity) {
    this.container
      .querySelector(`#CartDrawerItem-${line}`)
      ?.classList.add("thb-loading");

    const lineItemEl = this.container.querySelector(`#CartDrawerItem-${line}`);
    const lastQuantity = Number(lineItemEl?.dataset.productQuantity || 0);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname == "/apps/advanced-wishlist" ? "/" : window.location.pathname,
    });

    dispatchCustomEvent("line-item:change:start", {
      quantity: quantity,
    });
    if (this.container.querySelector(".product-recommendations--full")) {
      this.container
        .querySelector(".product-recommendations--full")
        .classList.remove("active");
    }
    fetch(`${theme.routes.cart_change_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      ...{
        body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        dispatchCustomEvent("line-item:change:end", {
          quantity: quantity,
          cart: parsedState
        });

        dispatchCustomEvent("dl:line-item:update", {
          quantity: quantity,
          cart: parsedState,
          lineItemEl: lineItemEl,
          lastQuantity: lastQuantity
        });

        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container
            .querySelector(`#CartDrawerItem-${line}`)
            .classList.remove("thb-loading");
        }
      });
  }
  refresh() {
    if (this.container.querySelector(".product-recommendations--full")) {
      this.container
        .querySelector(".product-recommendations--full")
        .classList.remove("active");
    }
    let sections = "cart-drawer,cart-bubble";
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState[section.section],
            section.selector
          );
        });

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    this.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    });
    this.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    this.querySelectorAll("video").forEach((video) => video.pause());
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-localization-forms")
      .forEach((localization) => {
        localization.addEventListener("change", (e) => {
          localization.querySelector("form").submit();
        });
      });
  }
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener("load", () => {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (
        e.target.matches(".resize-select") &&
        e.target.offsetParent !== null
      ) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener("resize.resize-select", function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement("option");
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement("select"),
      offset = 13;
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);
    if (
      sel.classList.contains("thb-language-code") ||
      sel.classList.contains("thb-currency-code") ||
      sel.classList.contains("facet-filters__sort")
    ) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== "undefined") {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-widget-title.collapsible")
      .forEach((button) => {
        button.addEventListener("click", (e) => {
          button.classList.toggle("active");
        });
      });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get("quick-view")) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById("Product-Drawer");
      this.body = document.body;

      this.addEventListener("click", this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace("//", "/");
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains("loading")) {
        return;
      }
      this.classList.add("loading");
      fetch(href, {
        method: "GET",
      })
        .then((response) => {
          this.classList.remove("loading");
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");
          const newModal = doc.querySelector('modal-dialog[id^="Notify-me-button"]');

          if (newModal?.id) {
            const staleModal = document.getElementById(newModal.id);
            if (staleModal) staleModal.remove();
          }

          const sectionInnerHTML = doc.querySelector("#Product-Drawer-Content").innerHTML;
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML =
          sectionInnerHTML;

        let js_files = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add("open-cc");
        this.body.classList.add("open-quick-view");
        this.drawer.classList.add("active");

        this.drawer.querySelector(".side-panel-close").focus();

        setTimeout(() => {
          this.drawer
            .querySelector(".product-quick-images--container")
            .classList.add("active");
        });
        dispatchCustomEvent("quick-view:open", {
          productUrl: href,
          productHandle: productHandle,
        });
        addIdToRecentlyViewed(productHandle);
      }
      HulkappWishlist._checkForProductStatus(Array.from(document.querySelectorAll(".side-panel.product-drawer.active product-form span.icon-wishlist-heart-empty")));
    }
  }
  customElements.define("quick-view", QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get("side-panel-content-tabs")) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll("button");
      this.panels = this.parentElement.querySelectorAll(
        ".side-panel-content--tab-panel"
      );
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() { }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove("tab-active");
      });
      this.buttons[i].classList.add("tab-active");

      this.panels.forEach((panel) => {
        panel.classList.remove("tab-active");
      });
      this.panels[i].classList.add("tab-active");
    }
  }

  customElements.define("side-panel-content-tabs", SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get("collapsible-row")) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector("details");
      this.summary = this.querySelector("summary");
      this.content = this.querySelector(".collapsible__content");

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector("summary").addEventListener("click", (e) =>
        this.onClick(e)
      );
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = "hidden";
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 250,
          easing: "ease",
        }
      );

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight
        }px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: "ease-out",
        }
      );
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = "";
    }
  }
  customElements.define("collapsible-row", CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector(".thb-product-detail");

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds && typeof recentIds !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem(
      "recently-viewed",
      JSON.stringify(window.recentlyViewedIds)
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof Localization !== "undefined") {
    new Localization();
  }
  if (typeof CartDrawer !== "undefined") {
    new CartDrawer();
  }
  if (typeof Header !== "undefined") {
    new Header();
  }
  if (typeof FooterMenuToggle !== "undefined") {
    new FooterMenuToggle();
  }
});

if (!customElements.get("show-password")) {
  class ShowPassword extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setupEventListener();
    }
    setupEventListener() {
      this.addEventListener("click", (e) => {
        e.preventDefault();
        let input = this.closest(".field").querySelector("input");
        if (input.type === "password") {
          input.type = "text";
          this.classList.add("active");
        } else {
          input.type = "password";
          this.classList.remove("active");
        }
      });
    }
  }
  customElements.define("show-password", ShowPassword);
}

document
  .querySelector("input#confirm_password")
  ?.addEventListener("input", (e) => {
    const password = document.querySelector("input#password");
    // compare password with confirm_password
    if (password.value !== e.target.value) {
      console.log("does not match");
      e.target.setCustomValidity("Passwords don't match");
    } else {
      console.log("match");
      e.target.setCustomValidity("");
    }

    e.target.reportValidity();
  });

if (!customElements.get("size-guide")) {
  class SizeGuide extends HTMLElement {
    constructor() {
      super();
      this.sizeData = JSON.parse(
        this.querySelector("script#sizeData").textContent
      );
      this.form = this.querySelector('form[name="size-guide"]');
      this.init();
      this.form.addEventListener("submit", (event) => {
        this.handleFormSubmit(event);
      });

      this.querySelectorAll('input[name="customerType"]').forEach((radio) => {
        radio.addEventListener("change", (event) => {
          this.handleCustomerTypeChange(event);
        });
      });

      // recalculate button
      this.querySelector('button[type="button"]#recalculate').addEventListener(
        "click",
        () => {
          // hide the result and show form
          this.querySelector("div.size-guide-result").style.display = "none";
          this.form.style.display = "block";
        }
      );
    }

    init() {
      this.updateSelectOptionsByCustomerType("men");
    }

    updateSelectOptionsByCustomerType(customerType) {
      //get the input for foot length and width
      const leftLengthSelect = this.querySelector("select#left-length");
      const leftWidthSelect = this.querySelector("select#left-width");
      const rightLengthSelect = this.querySelector("select#right-length");
      const rightWidthSelect = this.querySelector("select#right-width");

      //create the options for length and width using mens data
      const customerData = this.sizeData[customerType];

      //get the min and max length
      let minLength = Number.MAX_SAFE_INTEGER;
      let maxLength = Number.MIN_SAFE_INTEGER;

      customerData.forEach((item) => {
        item.width.forEach((size) => {
          minLength = Math.min(minLength, size.length.from);
          maxLength = Math.max(maxLength, size.length.to);
        });
      });

      //get the min and max width
      let minWidth = Number.MAX_SAFE_INTEGER;
      let maxWidth = Number.MIN_SAFE_INTEGER;

      customerData.forEach((item) => {
        item.width.forEach((size) => {
          minWidth = Math.min(minWidth, size.width.from);
          maxWidth = Math.max(maxWidth, size.width.to);
        });
      });

      // add the options to the select element
      leftLengthSelect.innerHTML = "";
      rightLengthSelect.innerHTML = "";

      for (let i = minLength; i <= maxLength; i++) {
        const option = document.createElement("option");
        option.value = i;
        option.textContent = i;
        leftLengthSelect.appendChild(option);
        rightLengthSelect.appendChild(option.cloneNode(true));
      }

      // add the options to width select element
      leftWidthSelect.innerHTML = "";
      rightWidthSelect.innerHTML = "";
      for (let i = minWidth; i <= maxWidth; i++) {
        const option = document.createElement("option");
        option.value = i;
        option.textContent = i;
        leftWidthSelect.appendChild(option);
        rightWidthSelect.appendChild(option.cloneNode(true));
      }
    }

    handleCustomerTypeChange(event) {
      const customerType = event.target.value;
      this.updateSelectOptionsByCustomerType(customerType);
    }

    handleFormSubmit(event) {
      event.preventDefault();

      const formData = new FormData(this.form);
      const customerType = formData.get("customerType");
      const leftLength = parseInt(formData.get("left-length"));
      const leftWidth = parseInt(formData.get("left-width"));
      const rightLength = parseInt(formData.get("right-length"));
      const rightWidth = parseInt(formData.get("right-width"));

      const sizeData = this.sizeData[customerType];

      let leftFootSize = {};
      let rightFootSize = {};

      let footSize = null;

      sizeData.forEach((item) => {
        item.width.forEach((size) => {
          if (
            size.length.from <= leftLength &&
            size.length.to >= leftLength &&
            size.width.from <= leftWidth &&
            size.width.to >= leftWidth
          ) {
            leftFootSize["size"] = item.size;
            leftFootSize["width"] = size.type;
          }
          if (
            size.length.from <= rightLength &&
            size.length.to >= rightLength &&
            size.width.from <= rightWidth &&
            size.width.to >= rightWidth
          ) {
            rightFootSize["size"] = item.size;
            rightFootSize["type"] = size.type;
          }
          if (leftFootSize && rightFootSize) {
            return;
          }
        });
      });

      if (leftFootSize.size.eu > rightFootSize.size.eu) {
        footSize = leftFootSize;
      } else {
        footSize = rightFootSize;
      }

      // display the result
      this.querySelector("span#eu-size").textContent = footSize.size.eu;
      this.querySelector("span#us-size").textContent = footSize.size.us;
      this.querySelector("span#width-size").textContent = footSize.type;

      // hide the form and show the result
      this.form.style.display = "none";
      this.querySelector("div.size-guide-result").style.display = "block";
    }
  }

  customElements.define("size-guide", SizeGuide);
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll(".convert-size")) {
    document.querySelectorAll(".convert-size").forEach(function (button) {
      button.addEventListener("click", function () {
        // remove active class from all buttons
        document.querySelectorAll(".convert-size").forEach(function (button) {
          button.classList.remove("active");
        });
        // add active class to the clicked button
        button.classList.add("active");
        console.log(button.dataset.value);
        button
          .closest(".product-form__input")
          .setAttribute("data-size", button.dataset.value);
      });
    });
  }
});

// if not initialized initialize a new instance of the class
if (!customElements.get("blogs-sidebar")) {
  class BlogsSidebar extends HTMLElement {
    constructor() {
      super();

      // initialize the open and close buttons
      this.openButton = this.querySelector("button.open-sidebar");
      this.closeButton = this.querySelector("button.close-sidebar");

      // add event listeners to the buttons
      this.openButton.addEventListener("click", this.openSidebar.bind(this));
      this.closeButton.addEventListener("click", this.closeSidebar.bind(this));
    }

    connectedCallback() {
      this.cc = document.querySelector(".click-capture");

      this.onClick = (e) => {
        let panel = document.querySelectorAll("blogs-sidebar.active");
        if (panel.length) {
          this.closeSidebar();
          this.cc.removeEventListener("click", this.onClick.bind(this));
          this.cc.removeAttribute("initialized");
        }
      };

      this.cc.addEventListener("click", this.onClick.bind(this));
      this.cc.setAttribute("initialized", "");
    }

    openSidebar() {
      document.body.classList.add("open-cc");
      this.classList.add("active");
      this.focus();
    }

    closeSidebar() {
      document.body.classList.remove("open-cc");
      this.classList.remove("active");
    }
  }

  customElements.define("blogs-sidebar", BlogsSidebar);
}

// custom 1774 page layout header brand logo hide and scale down the year logo based on scroll
document.addEventListener("DOMContentLoaded", function () {
  let customHeaderImgEl = document.querySelector(
    ".custom-header-logo-brand-image"
  );
  let customHeaderLogoImgEl = document.querySelector(
    ".custom-header-logo-image"
  );

  window.addEventListener("scroll", function () {
    let scrollPosition = window.scrollY;
    if (scrollPosition > 0) {
      customHeaderImgEl?.classList.add("custom-header-logo-visible");
      customHeaderLogoImgEl?.classList.add("custom-header-logo-scale");
    } else {
      customHeaderImgEl?.classList.remove("custom-header-logo-visible");
      customHeaderLogoImgEl?.classList.remove("custom-header-logo-scale");
    }
  });
});

// custom cursor style for 1774 pages
document.addEventListener("DOMContentLoaded", function () {
  const cursor = document.querySelector(".cursor-icon");

  if (cursor) {
    // Function to update cursor position
    function updateCursorPosition(e) {
      cursor.style.top = e.clientY + "px";
      cursor.style.left = e.clientX + "px";
      cursor.classList.add("is-shown");
    }

    // Function to handle mouseout
    function hideCursor(e) {
      cursor.classList.remove("is-shown");
    }

    // Function to add hover class
    function addHoverClass(e) {
      cursor.classList.add("hover");
    }

    // Function to remove hover class
    function removeHoverClass(e) {
      cursor.classList.remove("hover");
    }

    // Add event listeners for cursor movement and visibility
    document.addEventListener("mousemove", updateCursorPosition);
    document.addEventListener("mouseout", hideCursor);

    // Observe changes in the document body
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (
              node.matches(
                ".custom-layout-body a, .custom-layout-body button, .custom-layout-body input, .custom-layout-body label, .custom-layout-body details, .custom-layout-body .side-panel-close, .player, .flickity-nav, .dot, .back-to-top, .password-show-btn, custom-coupon-copy strong, .brz-popup2__close, .hulk_wl_icon-text, .icon-wishlist-cross, .product-card-quickview, .simpl-emi-icon, .custom-template-cursor"
              )
            ) {
              node.addEventListener("mouseover", addHoverClass);
              node.addEventListener("mouseout", removeHoverClass);
            }

            // If node contains clickable elements, add event listeners to them
            const clickableEls = node.querySelectorAll(
              ".custom-layout-body a, .custom-layout-body button, .custom-layout-body input, .custom-layout-body label, .custom-layout-body details, .custom-layout-body .side-panel-close, .player, .flickity-nav, .dot, .back-to-top, .password-show-btn, custom-coupon-copy strong, .brz-popup2__close, .hulk_wl_icon-text, .icon-wishlist-cross, .product-card-quickview, .simpl-emi-icon,.custom-template-cursor "
            );
            clickableEls.forEach(function (el) {
              el.addEventListener("mouseover", addHoverClass);
              el.addEventListener("mouseout", removeHoverClass);
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Initial setup for existing elements
    const initialClickableEls = document.querySelectorAll(
      ".custom-layout-body a, .custom-layout-body button, .custom-layout-body input, .custom-layout-body label, .custom-layout-body details, .custom-layout-body .side-panel-close, .player, .flickity-nav, .dot, .back-to-top, .password-show-btn, custom-coupon-copy strong, .brz-popup2__close, .hulk_wl_icon-text, .icon-wishlist-cross, .product-card-quickview, .simpl-emi-icon, .custom-template-cursor"
    );
    initialClickableEls.forEach(function (el) {
      el.addEventListener("mouseover", addHoverClass);
      el.addEventListener("mouseout", removeHoverClass);
    });
  }
});

/* custom component to toggle the cart login with checkout */
class cartLoginToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    /* cart toggle button for customer */
    this.querySelectorAll("[name='customers-account']").forEach((button) => {
      button.addEventListener("change", () => {
        if (button.value == "user-guest") {
          document.querySelector(".login-box").setAttribute("hidden", "");
          document.querySelector(".login-box").classList.remove("expand");
          document.querySelector(".login-box").classList.add("collapse");
          document
            .querySelector(".cart-form")
            .setAttribute("action", "/checkout");
        } else if (button.value == "user-registered") {
          document.querySelector(".login-box").removeAttribute("hidden");
          document.querySelector(".login-box").classList.remove("collapse");
          document.querySelector(".login-box").classList.add("expand");
          document
            .querySelector(".cart-form")
            .setAttribute("action", "/account/login?q=checkout");
        }
      });
    });
    this.querySelectorAll(".password-toggler").forEach((button) => {
      button.addEventListener("click", () => {
        var passwordInput = document.getElementById("password-field1");
        if (passwordInput.type === "password") {
          passwordInput.type = "text";
          document.querySelector(".show-password").setAttribute("hidden", "");
          document.querySelector(".hide-password").removeAttribute("hidden");
        } else {
          passwordInput.type = "password";
          document.querySelector(".show-password").removeAttribute("hidden");
          document.querySelector(".hide-password").setAttribute("hidden", "");
        }
      });
    });
  }
}
customElements.define("login-toggle-button", cartLoginToggle);

// custom copy coupon code on Available offers

class CustomCouponCopy extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const strongElements = this.querySelectorAll("strong");

    strongElements.forEach((strongEl) => {
      strongEl.addEventListener("click", () => {
        const textToCopy = strongEl.innerText;

        navigator.clipboard
          .writeText(textToCopy)
          .then(() => {
            strongEl.classList.add("copied");

            setTimeout(() => {
              strongEl.classList.remove("copied");
            }, 2000);
          })
          .catch((err) => {
            console.error("Failed to copy: ", err);
          });
      });
    });
  }
}
customElements.define("custom-coupon-copy", CustomCouponCopy);

// Section rendering for product card variants
class ProductCardVariant extends HTMLElement {
  constructor() {
    super();
    this.variantHandle = this.dataset.variantHandle;
    this.sectionId = this.dataset.sectionId;
    this.variantId = this.dataset.variantId;
    this.variantTitle = this.dataset.variantTitle;
    this.addEventListener("click", this.onVariantClick);
  }

  onVariantClick() {
    const url = `/products/${this.variantHandle}?section_id=custom-product-card-render`;
    const productCard = this.closest("product-card");

    if (!productCard) return;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const newProductCard = html.querySelector("product-card");
        const newWishlistIcon = html.querySelector("a.icon-wishlist-heart-empty.wishlist-btn");
        const productCardContainer = this.closest("li.column");
        const wishlistIcon = productCardContainer.querySelector("a.icon-wishlist-heart-empty.wishlist-btn");
        wishlistIcon.replaceWith(newWishlistIcon);

        if (newProductCard) {
          // Update product image
          const newImage = newProductCard.querySelector(".product-featured-image");
          if (newImage) {
            productCard.querySelector(".product-featured-image").innerHTML = newImage.innerHTML;
          }

          // Update product info (excluding color variant wrapper)
          const newProductInfo = newProductCard.querySelector(".product-card-info");
          if (newProductInfo) {
            const existingProductInfo = productCard.querySelector(".product-card-info");
            if (existingProductInfo) {
              existingProductInfo.innerHTML = newProductInfo.innerHTML;
            }
          }

          // Update active state in .color-variant-wrapper
          const colorVariants = productCard.querySelectorAll(".custom-color-option");
          colorVariants.forEach(variant => variant.classList.remove("custom-color-option-selected"));

          const selectedVariant = productCard.querySelector(`[data-variant-handle="${this.variantHandle}"] .custom-color-option`);
          if (selectedVariant) {
            selectedVariant.classList.add("custom-color-option-selected");
          }

          productCard.dataset.dlVariant = this.variantTitle;
          HulkappWishlist._checkForProductStatus(Array.from(productCardContainer.querySelectorAll("a.icon-wishlist-heart-empty")));
        }
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      });
  }
}

customElements.define("product-card-variant", ProductCardVariant);




// Tab switching for EU and UK sizes

class SizeSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `
      <div class="tab-wrapper">
        <button class="tab-btn" data-tab="eu">EU</button>
        <button class="tab-btn" data-tab="uk">UK</button>
      </div>
    `;

    this.euTab = this.querySelector('[data-tab="eu"]');
    this.ukTab = this.querySelector('[data-tab="uk"]');
    this.euSizes = document.querySelectorAll('.eu-size');
    this.ukSizes = document.querySelectorAll('.uk-size');
    this.listItems = document.querySelectorAll('.list-size li');

    // Restore tab state from localStorage if available
    const savedTab = localStorage.getItem('activeTab');
    if (savedTab === 'uk') {
      this.switchToUK();
    } else {
      this.switchToEU();
    }

    this.euTab.addEventListener('click', (event) => this.switchToEU(event));
    this.ukTab.addEventListener('click', (event) => this.switchToUK(event));
  }

  disconnectedCallback() {
    this.euTab.removeEventListener('click', this.switchToEU);
    this.ukTab.removeEventListener('click', this.switchToUK);
  }

  switchToEU(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    // Save active tab to localStorage
    localStorage.setItem('activeTab', 'eu');

    this.ukSizes.forEach(size => size.style.display = 'none');
    this.euSizes.forEach(size => size.style.display = 'inline');
    this.euTab.classList.add('active');
    this.ukTab.classList.remove('active');

    // Show all items when EU tab is active
    this.listItems.forEach(item => item.style.display = 'list-item');
  }

  switchToUK(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    // Save active tab to localStorage
    localStorage.setItem('activeTab', 'uk');

    this.euSizes.forEach(size => size.style.display = 'none');
    this.ukSizes.forEach(size => size.style.display = 'inline');
    this.ukTab.classList.add('active');
    this.euTab.classList.remove('active');

    // Filter items to only display those with UK sizes
    this.listItems.forEach(item => {
      const ukSize = item.querySelector('.uk-size');
      const ukSizeContent = ukSize ? ukSize.textContent.trim() : '';

      if (!ukSizeContent) {
        item.style.display = 'none';
      } else {
        item.style.display = 'list-item';
      }
    });
  }
}

customElements.define('size-selector', SizeSelector);



/* ********************************** Section Lazy loading ******************************************** */
class LazySection extends HTMLElement {
  static sectionsToFetch = [];

  constructor() {
    super();

    this.section = this.closest("section")?.id || this.closest("[id]").id;
    this.section = this.section?.replace("shopify-section-", "");

    this.trigger = this.dataset.triggerEvent || "intersection-observer";
    this.targetSelector = this.dataset.triggerTarget || "body";

    this.boundHandleMouseover = this.handleMouseover.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    const targetElement = document.querySelector(this.targetSelector);

    // Different triggers based on data-trigger attribute
    if (this.trigger === "mouseover") {
      if (screen.width < 990) return;

      targetElement.addEventListener("mouseover", this.boundHandleMouseover);
    } else if (this.trigger === "click") {
      targetElement.addEventListener("click", this.boundHandleClick);
    } else {
      // Default to intersection observer
      new IntersectionObserver(this.handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }
  }

  // Handler for intersection-observer trigger
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.fetchSections();
  }

  // Handler for mouseover trigger
  handleMouseover() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Handler for click trigger
  handleClick() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Common function for fetching sections
  fetchSections() {
    LazySection.sectionsToFetch.push(this.section);
    const sectionsToFetchBatch =
      LazySection.sectionsToFetch.length == 5
        ? LazySection.sectionsToFetch.splice(0, 5)
        : LazySection.sectionsToFetch;

    // Check if there is an ongoing network request
    if (LazySection.abortController) {
      LazySection.abortController.abort(
        "Section list updated, cancelling request."
      );
    }

    LazySection.abortController =
      sectionsToFetchBatch.length < 5 && new AbortController();

    fetch(
      window.location.pathname + "?sections=" + sectionsToFetchBatch.join(","),
      LazySection.abortController.signal
        ? { signal: LazySection.abortController.signal }
        : {}
    )
      .then((response) => response.json())
      .then((json) => {
        for (const [key, value] of Object.entries(json)) {
          const sectionContent = new DOMParser()
            .parseFromString(value, "text/html")
            .getElementById("shopify-section-" + key);

          if (sectionContent && sectionContent.innerHTML.trim().length) {
            const section = document.getElementById("shopify-section-" + key);
            section.innerHTML = sectionContent.innerHTML;

            document.dispatchEvent(
              new CustomEvent("lazy-section-loaded", {
                detail: { section }
              })
            );
            // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
            section.querySelectorAll("script").forEach((oldScriptTag) => {
              const newScriptTag = document.createElement("script");
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(
                document.createTextNode(oldScriptTag.innerHTML)
              );
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          }
        }

        if (sectionsToFetchBatch.length < 5) LazySection.sectionsToFetch = [];
      })
      .catch((e) => {
        console.warn(e);
      });
  }

  // Remove trigger based on data-target attribute
  removeTrigger() {
    const targetElement = document.querySelector(this.targetSelector);

    if (targetElement) {
      targetElement.removeEventListener("mouseover", this.boundHandleMouseover);
      targetElement.removeEventListener("click", this.boundHandleClick);
    }
  }
}

customElements.define("lazy-section", LazySection);

// Checking user enter 10 digit mobile number or not based on that showing error message
document.addEventListener("DOMContentLoaded", function () {
  const phoneInputs = document.querySelectorAll(".custom-phone");

  phoneInputs.forEach(function (phoneInput) {
    const form = phoneInput.closest("form");
    const errorSpan = form.querySelector(".custom-phone-error");
    const submitButton = form.querySelector(".custom-register-form");

    function validatePhoneNumber(showError = true) {
      const phoneValue = phoneInput.value.trim();
      const isValid = phoneValue.length === 10;

      if (isValid) {
        errorSpan.style.display = "none";
        submitButton.removeAttribute("disabled");
      } else {
        submitButton.setAttribute("disabled", "true");
        if (showError) {
          errorSpan.style.display = "flex";
        }
      }
    }

    phoneInput.addEventListener("blur", function () {
      validatePhoneNumber(true);
    });

    phoneInput.addEventListener("input", function () {
      validatePhoneNumber(false);
    });

    // Run once on load
    validatePhoneNumber(false);
  });
});


/* ********************************** Showing login popup ******************************************** */

document.addEventListener("DOMContentLoaded", function () {
  // Store elements in variables
  const popupTriggers = document.querySelectorAll(".popup-trigger");
  const closeButtons = document.querySelectorAll(".close-popup");
  const popups = document.querySelectorAll(".login-popup");

  // Open popup
  if (popupTriggers) {
    popupTriggers.forEach(function (trigger) {
      trigger.addEventListener("click", function (e) {
        // Get target popup using data attribute
        const targetPopupId = this.dataset.popupTarget;
        const targetPopup = document.getElementById(targetPopupId);

        if (targetPopup) {
          targetPopup.classList.remove("login-hidden");
        }
      });
    });
  }

  // Close popup
  if (closeButtons) {
    closeButtons.forEach(function (closeButton) {
      closeButton.addEventListener("click", function () {
        const parentPopup = this.closest(".login-popup");
        const signupPopup = this.closest(".signup-popup");
        if (parentPopup) {
          parentPopup.classList.add("login-hidden");
        }
        if (signupPopup) {
          signupPopup.classList.add("signup-hidden");
        }
      });
    });
  }

  // Close popup when clicking outside the content
  if (popups) {
    popups.forEach(function (popup) {
      popup.addEventListener("click", function (e) {
        if (e.target === this) {
          this.classList.add("login-hidden");
        }
      });
    });
  }
});

document.addEventListener("click", function (e) {
  // Check if the clicked element has the 'popup-trigger' class
  if (e.target.classList.contains("popup-trigger")) {
    // Get target popup using data attribute
    const targetPopupId = e.target.dataset.popupTarget;
    const targetPopup = document.getElementById(targetPopupId);

    if (targetPopup) {
      targetPopup.classList.remove("login-hidden");
    }
  }
});

/* ********************************** login popup to register popup ******************************************** */

document.addEventListener("DOMContentLoaded", function () {
  // Store elements in variables
  const registerButton = document.querySelector(".register-btn");
  const backToLoginButton = document.querySelector(".back-to-login");
  const loginContainer = document.querySelector(".login-popup-container");
  const registerContainer = document.querySelector(".signup-popup-container");

  // Check if the register button exists before adding an event listener
  if (registerButton) {
    registerButton.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default action

      // Hide the login container if it exists
      if (loginContainer) {
        loginContainer.classList.add("hidden");
      }

      // Show the register container if it exists
      if (registerContainer) {
        registerContainer.classList.remove("hidden");
      }
    });
  }

  // Check if the back-to-login button exists before adding an event listener
  if (backToLoginButton) {
    backToLoginButton.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default action

      // Hide the register container if it exists
      if (registerContainer) {
        registerContainer.classList.add("hidden");
      }

      // Show the login container if it exists
      if (loginContainer) {
        loginContainer.classList.remove("hidden");
      }
    });
  }
});

document.addEventListener("click", function (e) {
  // Check if the clicked element has the 'register-btn' class
  if (e.target.classList.contains("register-btn")) {
    // Get target popup using data attribute
    let loginContainer = document.querySelector(".login-popup-container");
    let registerContainer = document.querySelector(".signup-popup-container");

    // Hide the login container if it exists
    if (loginContainer) {
      loginContainer.classList.add("hidden");
    }

    // Show the register container if it exists
    if (registerContainer) {
      registerContainer.classList.remove("hidden");
    }
  }
});

document.addEventListener("click", function (e) {
  // Check if the clicked element has the 'back-to-login' class
  if (e.target.classList.contains("back-to-login")) {
    // Get target popup using data attribute
    let loginContainer = document.querySelector(".login-popup-container");
    let registerContainer = document.querySelector(".signup-popup-container");

    // Hide the register container if it exists
    if (registerContainer) {
      registerContainer.classList.add("hidden");
    }

    // Show the login container if it exists
    if (loginContainer) {
      loginContainer.classList.remove("hidden");
    }
  }
});
/* *************************************      Login popup for cart drawer       ********************************************** */

class LoginPopupElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Initialize popup logic when the element is added to the DOM
    this.initPopupLogic();
  }

  initPopupLogic() {
    const popupTriggers = this.querySelectorAll(".popup-trigger");

    // Open popup logic
    popupTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        const targetPopupId = trigger.dataset.popupTarget;
        const targetPopup = document.getElementById(targetPopupId);

        if (targetPopup) {
          targetPopup.classList.remove("login-hidden");

          // Close popup when clicking outside the content
          targetPopup.addEventListener("click", (e) => {
            if (e.target === targetPopup) {
              targetPopup.classList.add("login-hidden");
            }
          });
        }
      });
    });
  }
}

// Define the custom element
customElements.define("login-popup-element", LoginPopupElement);

/* *************************************      Signup popup for cart drawer       ********************************************** */

class SignupPopupElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Initialize popup logic when the element is added to the DOM
    this.initPopupLogic();
  }

  initPopupLogic() {
    const popupTriggers = this.querySelectorAll(".signup-trigger");

    // Open popup logic
    popupTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        const targetPopupId = trigger.dataset.popupTarget;
        const targetPopup = document.getElementById(targetPopupId);

        if (targetPopup) {
          targetPopup.classList.remove("signup-hidden");

          // Close popup when clicking outside the content
          targetPopup.addEventListener("click", (e) => {
            if (e.target === targetPopup) {
              targetPopup.classList.add("signup-hidden");
            }
          });
        }
      });
    });
  }
}

// Define the custom element
customElements.define("signup-popup-element", SignupPopupElement);

/* ********************************** updating card drawer ******************************************** */

// Function to update the cart
async function updateCart() {
  // Prepare the updates object
  let updates = {};

  // Check if there are any product-cart-item elements
  const productCartItems = document.querySelectorAll(".product-cart-item");
  if (productCartItems.length > 0) {
    productCartItems.forEach((item) => {
      // Get variant ID and quantity from data attributes
      const variantId = item.getAttribute("data-variant-id");
      const productQuantity = item.getAttribute("data-product-quantity");

      // Add to updates object if valid data is found
      if (variantId && productQuantity) {
        updates[variantId] = parseInt(productQuantity, 10); // Ensure quantity is a number
      }
    });
  }

  // Check if updates object is not empty
  if (Object.keys(updates).length === 0) {
    return;
  }

  try {
    // Send the update request to Shopify
    const updateResponse = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    });

    if (!updateResponse.ok) {
      const errorText = await updateResponse.text();
      throw new Error(
        `Cart update failed with status: ${updateResponse.status}. Response: ${errorText}`
      );
    }

    const updatedCart = await updateResponse.json();

    // Fetch the updated cart drawer content
    const url = "https://www.birkenstock.in/cart?section_id=cart-drawer";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const cartResponse = await response.text();
      const parser = new DOMParser();
      const cartHTML = parser.parseFromString(cartResponse, "text/html");

      // Check if Cart-Drawer exists before updating
      const cartDrawer = document.querySelector("#Cart-Drawer");
      if (cartDrawer) {
        cartDrawer.innerHTML = cartHTML.querySelector("#Cart-Drawer").innerHTML;
      }
    } catch (error) {
      console.error("Error fetching cart drawer content:", error.message);
    }
  } catch (error) {
    console.error("Error updating the cart:", error.message);
  }
}

// Call the function only if necessary elements exist
if (
  document.querySelectorAll(".product-cart-item").length > 0 ||
  document.querySelector("#Cart-Drawer")
) {
  updateCart();
}

/* ******************************************  destroy moengage sesstion  ****************************************************** */

document.addEventListener("DOMContentLoaded", function () {
  const logoutButtons = document.querySelectorAll(".logout-button"); // Select all logout buttons

  if (logoutButtons) {
    logoutButtons.forEach((logoutButton) => {
      logoutButton.addEventListener("click", function () {
        // Call MoEngage destroy session
        Moengage.destroy_session();
      });
    });
  }
});
/* ***************************************** closing moengage popup ******************************************** */
const popupIntervalId = setInterval(() => {
  const closeButton = document.querySelector(".brz-popup2__close");
  const campaignElement = document.getElementById(
    "moe-onsite-campaign-66335c088e9d5c39f30b6d1e"
  );

  if (closeButton && campaignElement) {
    // Add event listener
    closeButton.addEventListener("click", function () {
      campaignElement.style.zIndex = "0";
      campaignElement.style.inset = "unset";
    });
    // Clear the interval once the listener is added
    clearInterval(popupIntervalId);
  }
}, 500); // Check every 500ms
/* ***************************************** custom size converter ******************************************** */
class SizeConverter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `
          <span class="form__label__value">
              <button data-value="EU" class="convert-size active">EU</button>
              <span>|</span>
              <button data-value="UK" class="convert-size">UK</button>
          </span>
      `;

    this.setupEventListeners();
  }

  setupEventListeners() {
    const buttons = this.querySelectorAll(".convert-size");

    // Exit if no buttons exist
    if (buttons.length === 0) return;

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        if (!button) return;

        // Remove active class from all buttons
        buttons.forEach((btn) => btn.classList.remove("active"));

        // Add active class to clicked button
        button.classList.add("active");

        // Update data-size on the closest .product-form__input if it exists
        const parentForm = this.closest(".product-form__input");
        if (parentForm) {
          parentForm.setAttribute("data-size", button.dataset.value);
        }
      });
    });
  }
}

// Define the custom element
customElements.define("size-converter", SizeConverter);

/* ***************************************** custom size converter ******************************************** */
class ToggleSizeConverter extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
      this.innerHTML = `
          <span class="form__label__value toggle-switch">
              <button data-value="EU" class="toggle-option active"><span>EU</span></button>
              <button data-value="UK" class="toggle-option"><span>UK</span></button>
          </span>
      `;

      this.setupEventListeners();
  }

  setupEventListeners() {
      const buttons = this.querySelectorAll(".toggle-option");

      // Exit if no buttons exist
      if (buttons.length === 0) return;

      buttons.forEach((button) => {
          button.addEventListener("click", () => {
              if (!button) return;

              // Remove active class from all buttons
              buttons.forEach((btn) => btn.classList.remove("active"));

              // Add active class to clicked button
              button.classList.add("active");

              // Update data-size on the closest .product-form__input if it exists
              const parentForm = this.closest(".product-form__input");
              if (parentForm) {
                  parentForm.setAttribute("data-size", button.dataset.value);
              }
          });
      });
  }
}

// Define the custom element
customElements.define("toggle-size-converter", ToggleSizeConverter);

/* ***************************************** Mobile search result close option ******************************************** */
document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('side-panel-search-input');
  const customPanel = document.querySelector('.custom-side-panel');

  // Hide custom-side-panel when input is empty
  input.addEventListener('input', function () {
    if (input.value.trim() === '') {
      customPanel.classList.add('hidden');
    } else {
      customPanel.classList.remove('hidden');
    }
  });
});
/* ***************************************** Mobile search result close button ******************************************** */
class MobileSearchResultClose extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClose);
  }

  handleClose() {
    const panel = document.querySelector('.custom-side-panel');
    const input = document.getElementById('side-panel-search-input');

    if (panel) {
      panel.classList.add('hidden');
    }

    if (input) {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}

customElements.define('mobile-search-result-close', MobileSearchResultClose);

/* ***************************************** signup popup reload ******************************************** */

document.addEventListener("DOMContentLoaded", function () {
  const signupForms = document.querySelectorAll("#signup-popup form");

  signupForms.forEach(form => {
    form.addEventListener("submit", function () {
      // Save flag in session storage
      sessionStorage.setItem("signup_submitted", "true");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const signupSubmitted = sessionStorage.getItem("signup_submitted");

  // This data attribute could be set in your Liquid: <body data-customer-name="{{ customer.name | escape }}">
  const customerName = document.body.dataset.customerName || "";

  if (signupSubmitted === "true" && !customerName) {
    // Customer not detected yet → reload page
    sessionStorage.removeItem("signup_submitted");
    location.reload();
  } else {
    // Cleanup if everything is good
    sessionStorage.removeItem("signup_submitted");
  }
});

/* ***************************************** freebie panel ******************************************** */
class FreebieSelectButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector("button");
    this.panel = document.querySelector(".side-panel-freebie-wrapper");
    this.closeBtn = document.querySelector(".freebie-panel-close");
    this.cartContainer = document.querySelector(".product-cart-item--container");
    this.freebieSelectButton = document.querySelector("freebie-select-button");

    if (!this.panel) return;

    if (this.button) {
      this.button.addEventListener("click", () => {
        this.panel.classList.add("animating");
        requestAnimationFrame(() => {
          this.panel.classList.add("side-panel-freebie--open");
        });
        this.freebieSelectButton.classList.add("hidden");
        this.cartContainer.classList.add("freebie-open");
      });
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", () => {
        this.closePanel();
      });
    }
    document.addEventListener("click", (e) => {
      if (!this.panel.classList.contains("side-panel-freebie--open")) return;
      if (this.panel.contains(e.target)) return;
      if (this.cartContainer.contains(e.target)) return;
      this.closePanel();
    });
  }

  closePanel() {
    this.panel.classList.add("freebie-close-animating");
    this.panel.classList.remove("side-panel-freebie--open");
    this.freebieSelectButton.classList.remove("hidden");
    this.cartContainer.classList.remove("freebie-open");
    setTimeout(() => {
      this.panel.classList.remove("animating");
    }, 350);
  }
}

customElements.define("freebie-select-button", FreebieSelectButton);

/* ***************************************** free shipping bar ******************************************** */
class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.update();
  }

  update() {
    const free_shipping = this;

    const hasFreebie = document.querySelector('[data-freebie="true"]');

    const amountText = free_shipping.querySelector('.freebie-amount-text');
    const celebrationText = free_shipping.querySelector('.freebie-celebration-text');

    if (hasFreebie) {
      amountText?.classList.add('hidden');
      celebrationText?.classList.remove('hidden');
    } else {
      amountText?.classList.remove('hidden');
      celebrationText?.classList.add('hidden');
    }

    let amount_text = free_shipping.querySelector(".free-shipping--text span");

    const total = parseInt(free_shipping.dataset.cartTotal || "0", 10);

    const baseMinimum = parseInt(free_shipping.dataset.minimum || "0", 10);

    const rate =
      typeof Shopify !== "undefined" &&
        Shopify.currency &&
        Shopify.currency.rate
        ? Shopify.currency.rate
        : 1;

    const minimum = Math.round(baseMinimum * rate);

    let percentage = 1;

    if (total < minimum) {
      percentage = total / minimum;

      if (amount_text) {
        const remaining = minimum - total;
        const format =
          (window.theme &&
            window.theme.settings &&
            window.theme.settings.money_with_currency_format) ||
          "${{amount}}";

        amount_text.innerHTML = formatMoney(remaining, format);
      } else {
        if (amount_text) {
          amount_text.innerHTML = "";
        }
      }
    }

    free_shipping.style.setProperty("--percentage", percentage);
  }

}

customElements.define("free-shipping-bar", FreeShippingBar);

/* ***************************************** flying newsletter button ******************************************** */

document.addEventListener("DOMContentLoaded", function () {

  const flyInButton = document.getElementById("flyInButton");
  if (!flyInButton) return;

  const closeBtn = document.querySelector(".newsletter-close-button");
  const newsletterLink = document.querySelector(".newsletter-flyin-rotated-text");

  const storageKey = "newsletterClosed_" + window.location.pathname;

  if (sessionStorage.getItem(storageKey) === "true") {
    flyInButton.classList.add("flyout-hidden");
  }

  function hideFlyin() {
    flyInButton.classList.add("flyout-hidden");
    sessionStorage.setItem(storageKey, "true");
  }

  closeBtn?.addEventListener("click", hideFlyin);
  newsletterLink?.addEventListener("click", hideFlyin);

});
/* ***************************************** hide available offer section ******************************************** */
function hideEmptyOfferWrappers() {
  document.querySelectorAll('.available-offer-wrapper').forEach(wrapper => {
    const couponElement = wrapper.querySelector('custom-coupon-copy');
    const offerElement = wrapper.querySelector('.liquid-offer-msg-pdp ul');

    const couponEmpty =
      !couponElement ||
      couponElement.innerHTML.replace(/\s/g, '') === '';

    const offerEmpty =
      !offerElement ||
      offerElement.innerHTML.replace(/<[^>]*>/g, '').trim() === '';

    if (couponEmpty && offerEmpty) {
      wrapper.style.display = 'none';
    }
  });
}

window.addEventListener('load', function () {
  setTimeout(hideEmptyOfferWrappers, 100);
});

document.addEventListener('cart-drawer:open', function () {
  setTimeout(hideEmptyOfferWrappers, 100);
});

/* ***************************************** Read more / less product description ******************************************** */

document.addEventListener('DOMContentLoaded', function () {
  const description = document.getElementById('product-description');
  const toggle = document.getElementById('product-description-toggle');

  if (!description || !toggle) return;

  const isOverflowing =
    description.scrollHeight > description.clientHeight;

  if (isOverflowing) {
    toggle.style.display = 'inline-block';
  }

  toggle.addEventListener('click', function () {
    console.log('toggle clicked');
    const isExpanded = description.classList.toggle('is-expanded');

    toggle.textContent = isExpanded ? 'Read Less' : 'Read More';
    toggle.setAttribute('aria-expanded', isExpanded);
  });
});